import { Component, EventEmitter, inject, Input, OnInit, Output } from "@angular/core";
import { Accounts, BillerInterface } from "@tae/interfaces";
import { StorageService } from "@tae/services";
import { PictureBasicCardInterface } from "src/app/interfaces/basic-card.interface";
import { LabelsCardInterface } from "src/app/interfaces/labels.interface";
import {
  PageViewInferface,
  SetEventInterface,
} from "src/app/interfaces/tagging.interface";
import { BottomSheetService } from "src/app/services/bottomSheet/bottom-sheet.service";
import { CtrlRechargeService } from "src/app/services/ctrl-recharge/ctrl-recharge.service";
import { TaggingService } from "src/app/services/tagging.service";
import { DetailsRechargesConstants } from '@tae/constants';
import { DatePipe } from "@angular/common";

/**
 * Component DialogCardComponent.
 *
 * @export
 * @class DialogCardComponent
 */
@Component({
    selector: "sn-dialog-card",
    templateUrl: "./dialog-card.component.html",
    styleUrls: ["./dialog-card.component.scss"],
    standalone: false
})
export class CardDialog implements OnInit {
  public data: any;

  @Input() labels: LabelsCardInterface;

  @Input() biller: BillerInterface;

  @Input() card: Accounts;

  @Input() amount: number;

  @Input() cel: string;

  @Input() isRechargeSchedule: boolean = false;

  @Input() confirmRechargeSchedule: boolean = false;

  @Input() alias: string;

  @Output() success = new EventEmitter<boolean>();

  public frecuency: string = "mensuales";

  public arrayDetailsRecharges = DetailsRechargesConstants;

  public billerLogo: string;

  successStatus = "default";

  private bss = inject(BottomSheetService);
  private taggingService = inject(TaggingService);
  private storageService = inject(StorageService);
  private ctrlRecharge = inject(CtrlRechargeService);
  private _datePipe = inject(DatePipe);

  public get buildDetailAccount(): string {
    const { card, account } = this.card;
    const { cardType, cardNumber } = card;
    const { accountNumber } = account;
    if (cardType === "TDC") {
      return `${cardType} ${cardNumber.slice(0, 4)}**${cardNumber.slice(-4)}`;
    }
    return `CTA ${accountNumber.slice(0, 2)}**${accountNumber.slice(-4)}`;
  }

  public get picture(): PictureBasicCardInterface {
      return this.ctrlRecharge.getPicture(this.biller.billerId);
    }

  closeDialog(): void {
    this.bss.hide();
  }

  changeSlideSuccess() {
    const categoria = this.isRechargeSchedule ? 'pago_automatico' : 'recarga_celular';
    const url = this.confirmRechargeSchedule ? 'pago_automatico/recarga_celular/confirmacion' : 'recarga_celular/confirmacion'
    const action: SetEventInterface = {
      event: "payments",
      categoria,
      accion: "confirmacion",
      etiqueta: "desliza_para_confirmar",
      canalBanco: "supermovil",
      url,
      userID: "",
    };

    this.taggingService.setEvent(action);
    this.successStatus = "success";
    this.success.emit(true);
    if (this.data?.$confirmDialog) {
      this.data.$confirmDialog.next(true);
    }
    this.closeDialog();
  }

  private _setArrayDetails() {
    if (this.isRechargeSchedule) {
      const getDate = this.data?.arrayDetailsRecharges.find(item => item.id === 'rechargeFirst');
      const fisrtDate = this._datePipe.transform(getDate?.data, 'dd/MM/yy');

      this.arrayDetailsRecharges = this.arrayDetailsRecharges.map((item) => {
        if (item.id === "number") {
          return { ...item, value: this.cel };
        } else if (item.id === "account") {
          return { ...item, value: this.buildDetailAccount };
        } else if (item.id === "nextPayment") {
          return { ...item, value: fisrtDate}; 
        }
        return item;
      });
    }
  }

  ngOnInit(): void {
    if (this.data) {
      this.setData();
      this.labels = this.data?.labels;
      this.biller = this.data?.biller;
      this.card = this.data?.card;
      this.amount = this.confirmRechargeSchedule && this.isRechargeSchedule ? this.data?.arrayDetailsRecharges.find(item => item.id === 'amount')?.data : this.data?.amount;
      this.cel = this.data?.cel;
      this.isRechargeSchedule = this.data?.isRechargeSchedule || false;
      this.confirmRechargeSchedule = this.data?.confirmRechargeSchedule || false;
      this.alias = this.data?.arrayDetailsRecharges.find(item => item.id === 'alias')?.value;
      const getFrecuency = this.data?.arrayDetailsRecharges.find(item => item.id === 'frecuency')?.value;
      if (getFrecuency) {
        this.frecuency = `${getFrecuency.toLowerCase()}es`;
      }
      this.billerLogo = this.data?.biller?.urlBillerLogo;
      this._setArrayDetails();
    }
    const url = !this.confirmRechargeSchedule ? "recarga_celular/confirmacion" : 'pago_automatico/recarga_celular/confirmacion';
    const pageView: PageViewInferface = {
      url,
      canalBanco: "supermovil",
      titulo: url.replace(/\//g, '|'),
      subsection1: "recarga_celular",
      entorno: this.storageService.get("ENV"),
      versionApp: "",
      userId: "",
      marca: this.ctrlRecharge.recharge?.biller?.name,
      monto: this.amount?.toString(),
      event: "PageView",
      periodicidad: this.frecuency || undefined,
      proceso: this.frecuency ? 'recarga_automatica' : 'recarga_celular',
    };
    this.taggingService.setPageView(pageView);
  }

  private setData(): void {
    this.labels = this.data?.labels;
    this.biller = this.data?.biller;
    this.card = this.data?.card;
    this.cel = this.data?.cel;
    this.isRechargeSchedule = this.data?.isRechargeSchedule || false;
    this.confirmRechargeSchedule = this.data?.confirmRechargeSchedule || false;
    this.alias = this.data?.arrayDetailsRecharges.find(item => item.id === 'alias')?.value;
    this.amount = this.confirmRechargeSchedule && this.isRechargeSchedule ? this.data?.arrayDetailsRecharges.find(item => item.id === 'amount')?.data : this.data?.amount;
    const getFrecuency = this.data?.arrayDetailsRecharges.find(item => item.id === 'frecuency')?.value;
    if (getFrecuency) {
      this.frecuency = `${getFrecuency.toLowerCase()}es`;
    }
    this.billerLogo = this.data?.biller?.urlBillerLogo;
    this._setArrayDetails();
  }
}
